import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { StoreWorkshops } from '@thd-olt-component-react/store-workshops';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { HomepageContext } from './context/HomepageContext';

const { number, shape, string } = proptypes;

export function OnlineWorkshops({ id, renderWidths: { minWidthLarge } }) {
  const isCard = minWidthLarge < 5;
  const { isB2C } = useContext(HomepageContext);
  return (
    <ErrorBoundary name="online-workshops">
      <QueryProvider cacheKey="asd">
        <div
          id={`online-workshops-php-${id}`}
          className="sui-h-full"
        >
          <StoreWorkshops entryID={id} isCard={isCard} enableB2CRadius={isB2C} />
        </div>
      </QueryProvider>
    </ErrorBoundary>
  );
}

OnlineWorkshops.propTypes = {
  id: string,
  renderWidths: shape({
    minWidthLarge: number,
  }),
};

OnlineWorkshops.defaultProps = {
  id: undefined,
  renderWidths: {
    minWidthLarge: undefined,
  },
};
